/*
 * 案件種別
 */
/**
 * 案件種別: 公募（value）
 */
export const RFP_TYPE_PUBLIC_OFFERING_VALUE = 1;
/**
 * 案件種別: 公募
 */
export const RFP_TYPE_PUBLIC_OFFERING = {
    label: '公募案件',
    value: RFP_TYPE_PUBLIC_OFFERING_VALUE,
};
/**
 * 案件種別: RFI/業務委託（value）
 */
export const RFP_TYPE_DIRECT_OFFER_VALUE = 2;
/**
 * 案件種別: RFI/業務委託
 */
export const RFP_TYPE_DIRECT_OFFER = {
    label: '直接紹介案件（Proffit Mart利用者限定）',
    value: RFP_TYPE_DIRECT_OFFER_VALUE,
};
export const RFP_RFP_TYPES = [RFP_TYPE_PUBLIC_OFFERING, RFP_TYPE_DIRECT_OFFER];
